module.exports = __webpack_public_path__ + "static/media/cpg_annaspathtopurchase.70601c11.png";